import { Layout, Section } from 'layout';
import { CategoriesListScreen } from 'pages/categories/screens/categories-list-screen';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

const CategoriesPage = () => {
  const match = useRouteMatch();

  return (
    <Layout type={'sidebar_page_layout'}>
      <Section name={'content'}>
        <Switch>
          <Route path={`${match.url}/list`} component={CategoriesListScreen} />
          <Redirect to={`${match.url}/list`} exact />
          <Route path='*' render={() => <Redirect to='/404' />} />
        </Switch>
      </Section>
    </Layout>
  );
};

export default CategoriesPage;
